(function ($) {
  var elementorHookRegistered = false;
  var widgetSelector = '[data-listing-actualites]';

  function initListingActualites($scope) {
    var $wrappers = $scope.is(widgetSelector) ? $scope : $scope.find(widgetSelector);
    $wrappers.each(function () {
      var $wrapper = $(this);
      if ($wrapper.data('listingActualitesInitialized')) return;
      $wrapper.data('listingActualitesInitialized', true);

      var xhr;
      var page = 1;
      var totalPages = 0;
      var requestId = 0;
      var endpoint = $wrapper.attr('data-listing-actualites-endpoint') || '/wp-json/penega/v1/actualites';
      var $container = $wrapper.find('[data-listing-actualites-items]').first();
      var $pagination = $wrapper.find('[data-listing-actualites-pagination]').first();
      var $tagSelect = $wrapper.find('[data-listing-actualites-tag]').first();
      var $status = $wrapper.find('[data-listing-actualites-status]').first();

      function setLoading(loading) {
        $wrapper.toggleClass('is-filtering', loading);
        $wrapper.find('.listing-loader').prop('hidden', !loading);
        $container.attr('aria-busy', loading ? 'true' : 'false');
        if (loading) $status.text('Chargement des articles…');
      }

      function getPageFromUrl() {
        var url = new URL(window.location.href);
        var match = url.pathname.match(/\/page\/(\d+)\/?$/);
        return Math.max(1, parseInt(match ? match[1] : url.searchParams.get('paged'), 10) || 1);
      }

      function restoreFiltersFromUrl() {
        var params = new URL(window.location.href).searchParams;
        var category = params.get('actualites_category') || '';
        $wrapper.find('.terms input').each(function () {
          $(this).prop('checked', $(this).val() === category);
        });
        if (!$wrapper.find('.terms input:checked').length) {
          $wrapper.find('.show-all input').prop('checked', true);
        }
        $tagSelect.val(params.get('actualites_tag') || '');
      }

      function updateUrl() {
        var url = new URL(window.location.href);
        var basePath = url.pathname.replace(/\/page\/\d+\/?$/, '').replace(/\/$/, '');
        url.pathname = basePath + (page > 1 ? '/page/' + page + '/' : '/');
        url.searchParams.delete('paged');
        var categories = getSelectedTerms();
        var tag = $tagSelect.val();
        if (categories.length) url.searchParams.set('actualites_category', categories[0]);
        else url.searchParams.delete('actualites_category');
        if (tag) url.searchParams.set('actualites_tag', tag);
        else url.searchParams.delete('actualites_tag');
        if (url.href !== window.location.href) {
          window.history.pushState(null, '', url.href);
        }
      }

      function getSelectedTerms() {
        var val = $wrapper.find('.terms input[type="radio"]:checked').val();
        return val ? [parseInt(val, 10)] : [];
      }

      function renderPagination() {
        $pagination.empty().prop('hidden', totalPages <= 1);
        if (totalPages <= 1) return;

        function addButton(label, target, disabled) {
          var $button = $('<button>', {
            type: 'button',
            class: 'btn btn-outline-black',
            text: label,
            disabled: disabled
          }).attr('data-listing-actualites-page', target);
          if (typeof label === 'number') {
            $button.attr('aria-label', 'Page ' + target);
            if (target === page) $button.attr('aria-current', 'page');
          }
          $pagination.append($button);
        }

        addButton('Précédent', page - 1, page === 1);
        var previous = 0;
        for (var i = 1; i <= totalPages; i++) {
          if (i !== 1 && i !== totalPages && Math.abs(i - page) > 2) continue;
          if (previous && i - previous > 1) {
            $pagination.append($('<span>', { text: '…', 'aria-hidden': 'true' }));
          }
          addButton(i, i, i === page);
          previous = i;
        }
        addButton('Suivant', page + 1, page === totalPages);
      }

      function loadPosts(targetPage, scrollToListing, syncUrl) {
        var currentRequestId = ++requestId;
        var focusAtStart = document.activeElement;
        if (xhr) xhr.abort();
        $container.find('.listing-actualites__error').remove();
        setLoading(true);
        $pagination.find('button').attr('aria-disabled', 'true');

        xhr = $.ajax({
          url: endpoint,
          method: 'GET',
          data: {
            type: 'post',
            page: targetPage,
            numberpost: 9,
            categories: getSelectedTerms(),
            tag: $tagSelect.val() || ''
          }
        }).done(function (res) {
          if (currentRequestId !== requestId) return;
          page = parseInt(res.page, 10) || targetPage;
          totalPages = parseInt(res.total_pages, 10) || 0;
          $container.html(res.html || '<p>Aucun article trouvé.</p>');
          var count = $container.find('.single-post').length;
          $status.text(count ? count + ' articles affichés. Page ' + page + ' sur ' + totalPages + '.' : 'Aucun article trouvé.');
          if (syncUrl) updateUrl();
          if (scrollToListing) {
            $container[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
            if (document.activeElement === focusAtStart) {
              $container.attr('tabindex', '-1')[0].focus({ preventScroll: true });
            }
          }
        }).fail(function (request, status) {
          if (currentRequestId !== requestId || status === 'abort') return;
          $status.text('');
          var $error = $('<p>', {
            class: 'listing-actualites__error',
            role: 'alert',
            text: 'Impossible de charger les articles. '
          });
          $('<button>', { type: 'button', class: 'btn btn-outline-black', text: 'Réessayer' })
            .on('click', function () { loadPosts(targetPage, scrollToListing, syncUrl); })
            .appendTo($error);
          $container.prepend($error);
        }).always(function () {
          if (currentRequestId !== requestId) return;
          setLoading(false);
          var paginationHadFocus = $pagination[0].contains(document.activeElement);
          renderPagination();
          if (paginationHadFocus) {
            $container.attr('tabindex', '-1')[0].focus({ preventScroll: true });
          }
          xhr = null;
        });
      }

      function resetPosts() {
        loadPosts(1, false, true);
      }

      $wrapper.find('.terms input').on('change.listingActualites', function () {
        $wrapper.find('.terms input').not(this).prop('checked', false);
        if ($wrapper.find('.terms input:checked').length === 0) {
          $wrapper.find('.show-all input').prop('checked', true);
        }
        resetPosts();
      });
      $tagSelect.on('change.listingActualites', resetPosts);
      $wrapper.on('click.listingActualites', '[data-listing-actualites-tag-id]', function (e) {
        e.preventDefault();
        $tagSelect[0].focus({ preventScroll: true });
        $tagSelect.val($(this).attr('data-listing-actualites-tag-id')).trigger('change');
      });
      $pagination.on('click.listingActualites', '[data-listing-actualites-page]', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if ($(this).attr('aria-disabled') === 'true') return;
        var targetPage = parseInt($(this).attr('data-listing-actualites-page'), 10);
        if (targetPage > 0 && targetPage <= totalPages && targetPage !== page) {
          loadPosts(targetPage, true, true);
        }
      });
      $(window).on('popstate.listingActualites', function () {
        restoreFiltersFromUrl();
        loadPosts(getPageFromUrl(), true, false);
      });
      restoreFiltersFromUrl();
      loadPosts(getPageFromUrl());
    });
  }

  function registerElementorHook() {
    if (elementorHookRegistered || !window.elementorFrontend || !window.elementorFrontend.hooks) return;
    elementorHookRegistered = true;
    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/listing-actualites.default', initListingActualites
    );
  }
  $(window).on('elementor/frontend/init', registerElementorHook);
  $(function () {
    registerElementorHook();
    initListingActualites($(document));
  });
})(jQuery);
